const VAT = {
  AT: [0, 0.1, 0.12, 0.2],
  AU: [0, 0.1],
  AX: [0, 0.1, 0.14, 0.24],
  BE: [0, 0.06, 0.12, 0.21],
  DE: [0, 0.05, 0.07, 0.16, 0.19],
  EE: [0, 0.1, 0.14, 0.24],
  FI: [0, 0.1, 0.14, 0.24],
  FR: [0, 0.021, 0.055, 0.1, 0.2],
  GB: [0, 0.05, 0.2],
  SE: [0, 0.06, 0.12, 0.25],
  INT: [0]
};

export const getVATOptions = (locale) => {
  return VAT[locale] || VAT.INT;
};
